import { createAuthRedirect } from '@disenchantment/auth-client';
import { PRODUCTION_URLS } from '@disenchantment/shared';

export const {
  APP_ENTRY_PATH,
  AUTH_CALLBACK_PATH,
  AUTH_ERROR_PATH,
  getAppOrigin,
  getAuthCallbackUrl,
  getAppEntryUrl,
  listSuggestedRedirectUrls,
} = createAuthRedirect({
  appEntryPath: '/dashboard',
  fallbackOrigin: import.meta.env.DEV ? 'http://localhost:5175' : PRODUCTION_URLS.marketing,
  extraRedirectPaths: ['/dashboard', '/dashboard/*', '/releases', '/releases/*'],
});
